import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import WithRender from "@/Pages/Admin/Modules/ManagePackage/tab/General/General/Views/general.html";
import Spinner from "@/Pages/Admin/Modules/Common/Controllers/Spinner";
import GeneralStore from "@/Pages/Admin/Modules/ManagePackage/Store/General";


import { trekService } from "@/Pages/Admin/Modules/ManagePackage/Services/Trekservice";
import { common } from "@/Pages/Admin/Modules/Common/Services/Common";
import ValidationError from "@/Pages/Admin/Modules/Common/Controllers/ValidationError";

import { flashService } from "@/Pages/Admin/Modules/Common/Services/FlashMessage/FlashService";

import GeneralModule from "@/Pages/Admin/Modules/ManagePackage/Store/General";
import { TrekModel } from "@/Pages/Admin/Modules/ManagePackage/model/TrekModel";
import { DestinationModel } from "@/Pages/Admin/Modules/ManagePackage/model/Master/DestinationModel";

@WithRender
@Component({
  components: {
    Spinner,
    'validation-error': ValidationError,
  }
})
export default class General extends Vue {
  protected ui: any = {};
  protected item: any = {};
  protected status: any = {};

  constructor() {
    super();
    this.status.Edit = false;

    this.ui = {
      index: {
        edit: -1,
        isEdit: false,
        delete: -1,
        up: 0,
        down: 0,
      },
      status: {
        isLoading: {
          generalList: false,
          tourTypeList: false,
          difficultyLevelList: false,
          masterDestinationList: false,
          pricingBasis: false,
        },
        postLoading: {
          generalList: false,
          difficultyLevelList: false,
          masterDestinationList: false,
        },
        canAdd: false,
      },
      error: {
        errors: [],
        validationErrors: {},
        hasError: false,
      },
    };
    this.item = {
      trekId: 0,
      generalList: new TrekModel({}),
      editGeneral: new TrekModel({}),
      destinationMaster: new DestinationModel({}),
    };
  }

  public beforeMount() {
    this.item.trekId = this.$route.query.id;
    this.getAllTourTypeList();
    this.getALLPricingBasis();
    this.getAllDifficultyLevelList();
    this.getALLMasterDestinationList();
  }

  public mounted() {
    this.getGeneral();
  }

  public getALLPricingBasis() {
    this.ui.status.isLoading.pricingBasis = true;
    GeneralStore.GetPricingBasis()
      .then((res: any) => { })
      .catch((error: any) => {
        common.sdCatchErr(error, this.ui.error.errors).then((res: any) => {
          this.ui.error.errors = res;
        });
      })
      .finally(() => {
        this.ui.status.isLoading.pricingBasis = false;
      });
  }

  get getPricingBasis() {
    return GeneralStore.PricingBasis;
  }

  public getAllTourTypeList() {
    this.ui.status.isLoading.tourTypeList = true;
    GeneralStore.GetTourTypeList()
      .then((res: any) => {})
      .catch((error: any) => {
        common.sdCatchErr(error, this.ui.error.errors).then((res: any) => {
          this.ui.error.errors = res;
        });
      })
      .finally(() => {
        this.ui.status.isLoading.tourTypeList = false;
      });
  }

  get getTourTypeList() {
    return GeneralStore.TourTypeList;
  }

  public getAllDifficultyLevelList() {
    this.ui.status.isLoading.difficultyLevelList = true;
    GeneralStore.GetDifficultyLevelList()
      .then((res: any) => {})
      .catch((error: any) => {
        common.sdCatchErr(error, this.ui.error.errors).then((res: any) => {
          this.ui.error.errors = res;
        });
      })
      .finally(() => {
        this.ui.status.isLoading.difficultyLevelList = false;
      });
  }

  get getDifficultyLevelList() {
    return GeneralStore.DifficultyLevelList;
  }

  protected async getALLMasterDestinationList() {
    this.ui.status.isLoading.masterDestinationList = true;
    trekService
      .getMasterDestinationList()
      .then((res: any) => {
        this.item.destinationMaster = res.data.data;
      })
      .catch((error: any) => {
        common.sdCatchErr(error, this.ui.error.errors).then((res: any) => {
          this.ui.error.errors = res;
        });
      })
      .finally(() => {
        this.ui.status.isLoading.masterDestinationList = false;
      });
  }

  protected getGeneral() {
    this.ui.IsLoading = true;
    const data = {
      trek_id: this.item.trekId,
    };
    trekService
      .getGeneralTabData(data)
      .then((res: any) => {
        this.ui.IsLoading = false;
        this.item.generalList = res.data.data;
      })
      .catch((error: any) => {
        common.sdCatchErr(error, this.ui.error.errors).then((res: any) => {
          this.ui.error.errors = res;
        });
      })
      .finally(() => {
        this.ui.IsLoading = false;
      });
  }

  get tourTypeId() {
    if (this.item.generalList.tour_type && this.item.generalList.tour_type.id) {
      return this.item.generalList.tour_type.id;
    } else {
      return "";
    }
  }

  get difficultyLevelId() {
    if (
      this.item.generalList.difficulty_level &&
      this.item.generalList.difficulty_level.id
    ) {
      return this.item.generalList.difficulty_level.id;
    } else {
      return "";
    }
  }

  get destinationId() {
    if (
      this.item.generalList.destination &&
      this.item.generalList.destination.id
    ) {
      return this.item.generalList.destination.id;
    }
  }

  get pricingBasisId() {
    if (
      this.item.generalList.pricing_basis &&
      this.item.generalList.pricing_basis.id
    ) {
      return this.item.generalList.pricing_basis.id;
    } else {
      return "";
    }
  }

  public get buttonName() {
    if (this.ui.PostLoading) {
      return "Processing...";
    }
    return "Save";
  }

  protected setGeneral() {
    this.ui.error.validationErrors = {};
    this.ui.error.errors = [];
    this.ui.error.hasError = false;

    if (!this.IsValidationTrue()) {
      return;
    }
    this.ui.status.postLoading.generalList = true;
    const data = {
      trek_id: this.item.trekId,
      title: this.item.generalList.title,
      teaser_title: this.item.generalList.teaser_title,
      tour_type_id: this.tourTypeId,
      // tour_type_id: this.item.generalList.tour_type.id,
      difficulty_level_id: this.difficultyLevelId,
      // difficulty_level_id: this.item.generalList.difficulty_level.id,
      altitude_in_meter: this.item.generalList.altitude_in_meter,
      altitude_in_feet: this.item.generalList.altitude_in_feet,
      description: this.item.generalList.description,
      destination_id: this.destinationId,
      // destination_id: this.item.generalList.destination.id,
      pricing_basis_id: this.pricingBasisId,
      // pricing_basis_id: this.item.generalList.pricing_basis.id,
      base_price: this.item.generalList.base_price
    };
    trekService
      .PutGeneral(data)
      .then((res: any) => {
        this.ui.error.hasError = false;
        this.item.generalList = res.data.data;
        GeneralModule.setPackageTitle(res.data.data);
        flashService.Success("General Data Saved", res.data.message);
      })
      .catch((error: any) => {
        common.sdCatchErr(error, this.ui.error.errors).then((res: any) => {
          this.ui.error.errors = res;
        });
      })
      .finally(() => {
        this.ui.status.postLoading.generalList = false;
        this.status.Edit = false;
      });
  }

  protected preventNonNumericalInput(event: any) {
    common.preventNonNumericalInput(event);
  }

  protected ConvertToFeet() {
    this.item.generalList.altitude_in_feet = common.ConvertToFeet(
      this.item.generalList.altitude_in_meter
    );
  }

  protected ConvertToMeter() {
    this.item.generalList.altitude_in_meter = common.ConvertToMeter(
      this.item.generalList.altitude_in_feet
    );
  }

  protected IsValidationTrue() {
    if (!this.item.generalList.title) {
      Object.assign(this.ui.error.validationErrors, {
        title: ["The title field is required."]
      });
    }
    if (!this.item.generalList.teaser_title) {
      Object.assign(this.ui.error.validationErrors, {
        teaser_title: ["The teaser title field is required."]
      });
    }
    if (!this.item.generalList.tour_type) {
      Object.assign(this.ui.error.validationErrors, {
        tour_type_id: ["The tour type field is required."]
      });
    }
    if (!this.item.generalList.difficulty_level) {
      Object.assign(this.ui.error.validationErrors, {
        difficulty_level_id: ["The difficulty level field is required."]
      });
    }
    if (!this.item.generalList.description) {
      Object.assign(this.ui.error.validationErrors, {
        description: ["The description field is required."]
      });
    }
    if (!this.item.generalList.destination) {
      Object.assign(this.ui.error.validationErrors, {
        destination_id: ["The destination field is required."]
      });
    }
    if (common.notEmpty(this.ui.error.validationErrors)) {
      this.ui.error.hasError = true;
      return false;
    } else {
      return true;
    }
  }

  protected editGeneral() {
    this.status.Edit = true;
    this.item.editGeneral = Object.assign({}, new TrekModel({}));
    this.item.editGeneral = Object.assign({}, this.item.generalList);
  }

  protected cancelGeneralEdit() {
    this.status.Edit = false;
    this.ui.error.errors = [];
    this.ui.error.validationErrors = {};
    this.ui.error.hasError = false;
    this.item.generalList = this.item.editGeneral;
  }

  protected hideIcon() {
    $(".informative-block").hide();
  }
}
